import graphql__4d52d88167dbc747cc46 from "./__generated__/AnalyticsDataTextRow_analyticsData.graphql.js";import { createFragmentContainer } from "react-relay";
import { graphql } from "react-relay";

import AnalyticsDatumText from "./AnalyticsDatumText";

const AnalyticsDataTextRow = props => {
  const { analyticsData } = props;

  if (!analyticsData.length) return null;

  return (
    <div className="analytics-data-text-row d-flex flex-row">
      {analyticsData.map(analyticsDatum => (
        <AnalyticsDatumText key={analyticsDatum.id} analyticsDatum={analyticsDatum} />
      ))}
    </div>
  );
};

export default createFragmentContainer(AnalyticsDataTextRow, {
  analyticsData: graphql__4d52d88167dbc747cc46
});
